export function sanitise(username: string): string {
  return username.replace(/\s/g, '');
}
